import React, { Component } from "react";
import {
  Wrapper,
  CardBody,
  Card,
  Title,
  Copy,
  Bold,
  Row
} from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";

import { loadPlans, renderPrice, openUrl } from "app/NativeActions";
import PlanFeature from "../Engines/EnginePlans/PlanFeature";

class AllEngineFeatures extends Component {
  constructor(props) {
    super(props);

    this.state = {
      plan: null,
      loading: true
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    loadPlans("all_plans")
      .then(data => {
        if (data && data.items && data.items.length > 0) {
          this.setState({ plan: data.items[0] });
        }
        this.setState({ loading: false });
      })
      .catch(err => {
        this.setState({ loading: false });
      });
  }

  render() {
    const { plan } = this.state;
    if (plan) {
      return (
        <Wrapper>
          {plan.fields.features &&
            plan.fields.features.map((feature, i) => {
              return (
                <PlanFeature
                  key={i}
                  feature={feature}
                  colors={this.props.colors}
                />
              );
            })}
        </Wrapper>
      );
    }

    return null;
  }
}

export default AllEngineFeatures;
